import "../services.css"
import "../servicescovers.css"

import { useState, useRef, useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';
import R from "../../../assets/Images/Quote/Hero-Section.jpg"

import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"
import QuotationComponent from "../../../assets/components/06_quotation_component/quotation_component"
import test from "../../../assets/Images/Elements/M-Orange.svg"

export default function PaidAdvertising() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 8;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <HelmetProvider>
                <title>Performance-Driven Advertising Services for Brands in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai providing paid advertising on Meta & Google Ads, social media marketing in Mumbai, and Instagram marketing agency solutions for growth." />
                <link rel="canonical" href="/services/paid-advertising" />
            </HelmetProvider>
            <Header />
            <div className="ServicesDetails-HeroSection ServicesDetails-HeroSection-Website">
                <div className="ServicesDetails-HeroSection-Glass">
                    <h1>Paid Advertising Services</h1>
                    <p>Adstrate, a trusted digital marketing agency in Mumbai, offers performance-focused Meta and Google Ads campaigns to drive leads, sales, and brand growth.</p>
                    <a href="/quotation">
                        <p className="LinkLabel">Get Quote</p>
                        <img src={Arrow}/>
                    </a>
                </div>
            </div>
            <div className="ServicesPages-Services-Main">
                <div className="ServicesPages-Services-Info">
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Discovery & Goal Definition</h2>
                            <p>
                                Understand campaign goals, budget, audience, and conversion objectives during a discovery call.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Strategy Development</h2>
                            <p>
                                Design advertising funnels, segment audiences, and select platforms to maximize performance.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Ad Account Setup</h2>
                            <p>
                                Configure Meta and Google Ads accounts, set conversion tracking, and define campaign structure.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Creative & Copy Development</h2>
                            <p>
                                Design ad creatives and copy aligned with brand messaging and campaign objectives.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Campaign Launch</h2>
                            <p>
                                Activate campaigns with scheduled delivery, platform targeting, and performance tracking.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Continuous Optimization</h2>
                            <p>
                                Monitor campaigns with A/B testing, budget adjustments, and audience refinement for higher ROI.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Performance Reporting</h2>
                            <p>
                               Provide transparent reports and review calls with actionable insights.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 8 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Offboarding & Recommendations</h2>
                            <p>
                                Deliver final performance documentation, scaling strategies, and recommendations for future campaigns.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ServicesPages-Services-Selector" ref={selectorRef}>
                    <div className="ServicesPages-Services-Selector-Selection">
                        {[
                        "Discovery & Goal Definition",
                        "Strategy Development",
                        "Ad Account Setup",
                        "Creative & Copy Development",
                        "Campaign Launch",
                        "Continuous Optimization",
                        "Performance Reporting",
                        "Offboarding & Recommendations",

                        ].map((text, index) => (
                        <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "ServicesPages-Services-Selector-Card Home-active MicroLinksText" : "ServicesPages-Services-Selector-Card"}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            <div className="ServicesPages-Services-Selector-selection"></div>
                            <div className="ServicesPages-Services-Selector-hover"></div>
                            <p>{text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
            <QuotationComponent />
            <Footer />
        </div>
    );
}